export enum Consumer {
    ARL = 'ARL'
}
